import { PaginatedResource, RecipeCollectionPreview } from '@/types';
import { ApiService } from '@/services/ApiService';

export class RecipeCollectionService extends ApiService {
    public listRecipeCollections(recipeSlug: string|undefined = undefined): Promise<PaginatedResource<RecipeCollectionPreview>> {
        return this.fetch(route('api.recipeCollections.index', { recipe: recipeSlug }));
    }

    public addRecipeToCollection(recipeSlug: string, collectionSlug: string): Promise<void> {
        return this.fetch(route('api.recipeCollections.addToCollection', { recipe: recipeSlug, collection: collectionSlug }), {
            method: 'POST'
        });
    }

    public removeRecipeFromCollection(recipeSlug: string, collectionSlug: string): Promise<void> {
        return this.fetch(route('api.recipeCollections.removeFromCollection', { recipe: recipeSlug, collection: collectionSlug }), {
            method: 'DELETE'
        });
    }
}
